import * as Graphql from "@hireroo/graphql/client/urql";

type Status = Graphql.SpotStatus;

export const hasSpotStatus = (status: Status, compareStatuses: Status[]): boolean => {
  const set = new Set<Status>(compareStatuses);
  return set.has(status);
};
